import {onBlockLoaded} from "@plaudit/frontend-apis";

function dialogModeIsDisabled(wrapper: Element) {
	return getComputedStyle(wrapper).getPropertyValue("--plaudit-base-generic-dialog-mode") === 'inline';
}

function updateDialogMode(wrapper: Element) {
	const dialog = wrapper.querySelector("dialog");
	if (dialog) {
		const dialogModeDisabled = dialogModeIsDisabled(wrapper);
		if (dialogModeDisabled && dialog.open) {
			dialog.close();
		}
		wrapper.classList.toggle("dialog-mode-disabled", dialogModeDisabled);
		updateButtonAriaAttributes(wrapper, dialog);
	}
}

function updateButtonAriaAttributes(wrapper: Element, dialog: HTMLDialogElement) {
	const dialogExpanded = (dialogModeIsDisabled(wrapper) || dialog.open).toString();
	for (const button of getButtons(wrapper)) {
		button.ariaExpanded = dialogExpanded;
	}
}

let nextDialogId = 0;
onBlockLoaded({
	blockOrClassName: "plaudit-base/generic-dialog",
	onAdd(wrapper) {
		const dialog = wrapper.querySelector<HTMLDialogElement>(".wp-block-plaudit-base-generic-dialog-body");
		if (!dialog) {
			return;
		}
		const id = wrapper.id || `dialog-${nextDialogId++}`;
		wrapper.id = id;
		dialog.id = id + "__dialog";

		if (!dialog.getAttribute("aria-labelledby")) {
			const header = wrapper.querySelector(".wp-block-plaudit-base-generic-dialog-header");
			if (header) {
				header.id = id + "__header";

				if ('ariaLabelledByElements' in Element.prototype) {
					dialog.ariaLabelledByElements = [header];
				} else {
					dialog.setAttribute("aria-labelledby", header.id);
				}
			}
		}

		for (const button of getButtons(wrapper)) {
			if (!button.hasAttribute("aria-controls")) {
				if ('ariaControlsElements' in Element.prototype) {
					button.ariaControlsElements = [dialog];
				} else {
					button.setAttribute("aria-controls", dialog.id);
				}
			}
		}

		updateDialogMode(wrapper);
		dialog.addEventListener('close', () => {
			updateButtonAriaAttributes(wrapper, dialog);
		});
	}
});

function getButtons(wrapper: Element) {
	return wrapper.querySelectorAll<HTMLButtonElement>(".wp-block-plaudit-base-generic-dialog-button button");
}

function debounce<T extends any[]>(this: void, func: (...args: T) => void, delay?: number, immediate = false): typeof func {
	let timerId: ReturnType<typeof setTimeout>|undefined = undefined;
	return (...args: T) => {
		const boundFunc = func.bind<void, T, [], void>(this, ...args);
		clearTimeout(timerId);
		if (immediate && !timerId) {
			boundFunc();
		}
		const calleeFunc = immediate ? () => { timerId = undefined } : boundFunc;
		timerId = setTimeout(calleeFunc, delay);
	};
}

window.addEventListener('resize', debounce(() => document.querySelectorAll(".wp-block-plaudit-base-generic-dialog").forEach(updateDialogMode)));
